import React from 'react';

import DfSearch from '../components/df-search';
import ActiveFilters from '../components/active-filters';
import Grid from '../components/grid';
import GridNavigation from '../components/grid-navigation';
import GridResults from '../components/grid-results';
import Toast from '../components/toast';
import Results from '../components/results';
import { DfResultsProvider } from '../context/results/df-results-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PAGE_VARIANT } from '../constants';
import ErrorBoundary from '../api/error-boundary';
import { DfCategoriesProvider } from '../context/categories/df-categories-provider';

const client = new QueryClient();

export default function DfResults(): React.ReactElement {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={client}>
        <DfCategoriesProvider>
          <DfResultsProvider>
            <Grid className="section-title">
              <Toast />
              <DfSearch variant={PAGE_VARIANT.RESULT} />
            </Grid>
            <ActiveFilters />
            <Results>
              <GridNavigation />
              <GridResults />
            </Results>
          </DfResultsProvider>
        </DfCategoriesProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
